import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { Gender } from "../../models/gender.model";

export namespace GenderActions {

  @logDispatcher
  export class GetGenders {
    static readonly type = '[Gender] GetGenders';
    constructor() { }
  }

  @logDispatcher
  export class GetGendersSuccess {
    static readonly type = '[Gender] GetGendersSuccess';
    constructor(public genders: Gender[]) { }
  }

  @logDispatcher
  export class GetGendersFail {
    static readonly type = '[Gender] GetGendersFail';
    constructor(public error: any) { }
  }
}
